<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({ name: 'ToText' });
</script>
<template>
	<component :is="link ? 'a' : 'span'" ref="$el2" v-size="size" :flex="flex ? flex : null" :href="href ? href : link ? 'javscript:void(0)' : ''" class="to-text" :class="setClass" :style="setStyle">
		<slot name="icon">
			<to-icon v-if="props.icon" class="to-text-icon" :value="props.icon"></to-icon>
		</slot>
		<slot>{{ iData }}</slot>
		<template v-if="isOver">...</template>
	</component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ToIcon } from '@touchvue/components'
import { vSize } from '@touchvue/directives'


interface Props {
	flex?: boolean
	data?: string
	indent?: number | string
	mode?: string
	size?: number | string
	family?: string
	weight?: number | string
	color?: string
	lineHeight?: number | string
	decos?: string | string[]
	width?: number | string
	row?: number | string
	count?: number | string
	link?: boolean
	gd?: boolean
	href?: string
	icon?: string
}

const props = withDefaults(defineProps<Props>(), {
	data: '',
	mode: '',
	size: '',
	family: '',
	weight: '',
	color: '',
	indent: 0,
	lineHeight: '',
	decos: '',
	width: '',
	row: '',
	count: '',
	link: false,
	gd: false,
	href: '',
	icon: ''
})

// class 计算
const setClass = computed(() => {
	const arr: string[] = []

	if (props.link) arr.push('is-link')
	if (props.gd) arr.push('is-gd')
	if (props.mode) arr.push(`mode-${props.mode}`)
	if (props.color) arr.push(`color-${props.color}`)
	if (props.indent) arr.push(`is-indent`)
	if (props.width) arr.push(`type-width`)
	if (props.row) arr.push(`type-row`)
	if (props.count) arr.push(`type-count`)

	// 处理 decos
	let decosArr: string[] = []
	if (Array.isArray(props.decos)) {
		decosArr = props.decos
	} else if (typeof props.decos === 'string') {
		decosArr = props.decos.split(',').map(item => item.trim())
	}
	const validDecos = ['i', 'u', 'd', 's', 'b', 'e']
	decosArr.forEach(d => {
		if (validDecos.includes(d)) {
			arr.push(`decos-${d}`)
		}
	})

	return arr
})

// 计算 count 属性设置之后实际字符是否大于设定字符数
const isOver = computed(() => {
	if (!props.count || !props.data) return false

	const str = String(props.data)
	let visualLength = 0

	for (let i = 0; i < str.length; i++) {
		const char = str[i]
		const charCode = char.charCodeAt(0)

		// 判断字符宽度（中英文）
		if (charCode <= 0xff) {
			// 半角字符（英文等）
			visualLength += 0.5
		} else {
			// 全角字符、汉字等
			visualLength += 1
		}

		if (visualLength > Number(props.count)) {
			return true
		}
	}
	return false
})

// style 计算
const setStyle = computed(() => {
	const obj: Record<string, string | number> = {}
	if (props.weight) obj.fontWeight = props.weight
	if (props.indent) obj.textIndent = props.indent + 'em'
	if (props.width) obj.width = props.width + 'em'
	if (props.row) obj.webkitLineClamp = props.row
	if (props.family) obj.fontFamily = props.family
	if (props.lineHeight) obj.lineHeight = `${props.lineHeight}em`
	return obj
})

// count
const iData = computed(() => {
	if (!props.count || !props.data) return props.data

	const str = String(props.data)
	let result = ''
	let visualLength = 0

	for (let i = 0; i < str.length; i++) {
		const char = str[i]
		const charCode = char.charCodeAt(0)

		// 判断字符宽度（中英文）
		if (charCode <= 0xff) {
			// 半角字符（英文等）
			visualLength += 0.5
		} else {
			// 全角字符、汉字等
			visualLength += 1
		}

		if (visualLength > Number(props.count)) {
			break
		}
		result += char
	}
	return result
})
</script>
